import Transform from '@ember-data/serializer/transform';
import {
  flattenMoney,
  type Money,
} from 'lumen/utils/net-revenue/serializer-helpers';

export default class NetRevenueMoneyTransform extends Transform {
  deserialize(serialized: Money | number | null | undefined): number | null {
    return flattenMoney(serialized);
  }

  serialize(deserialized: number | null): number | null {
    return deserialized;
  }
}
